import { forwardRef } from "react";
import { useId } from "react";
const Input = forwardRef(function({label,type="text",classname="",...props},ref) {
    const inputId = useId();

    return (
        <> 
            {label && <label htmlFor={inputId} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label> }
            <input id={inputId} type={type}  className={`bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-indigo-600 focus:border-indigo-600 block w-full p-2.5" ${classname}`} {...props} ref={ref} />
        </>
     )
});

export default Input ;